module.exports = __webpack_public_path__ + "img/scene_1.f67be2d4.png";